import { unionWith, isEqual } from 'lodash'
import { createSelector } from 'reselect'

import { allGroupsOption } from '../../components/Groups/helpers'
import API from '../../api/api'

export const UPDATE_GROUP = 'UPDATE_GROUP'
export const CREATE_POST = 'CREATE_POST'
export const CREATE_POSTS = 'CREATE_POSTS'
export const DELETE_POST = 'DELETE_POST'
export const UPDATE_POST = 'UPDATE_POST'
export const JOIN_GROUP = 'JOIN_GROUP'
export const LEAVE_GROUP = 'LEAVE_GROUP'
export const SET_GROUPS = 'SET_GROUPS'
export const SET_POSTS_TO_GORUP = 'SET_POSTS_TO_GORUP'
export const LIKE_POST = 'LIKE_POST'
export const DISLIKE_POST = 'DISLIKE_POST'
export const LIKE_COMMENT = 'LIKE_COMMENT'
export const DISLIKE_COMMENT = 'DISLIKE_COMMENT'
export const ADD_COMMENT = 'ADD_COMMENT'
export const DELETE_COMMENT = 'DELETE_COMMENT'
export const EDIT_COMMENT = 'EDIT_COMMENT'
export const SET_REFRESHING = 'SET_REFRESHING'
export const SET_LOADING_POSTS = 'SET_LOADING_POSTS'
export const UPDATE_NOTIFICATIONS = 'UPDATE_NOTIFICATIONS'
export const SET_LOADING_MEMBERS = 'SET_LOADING_MEMBERS'
export const SET_GROUP_MEMBERS = 'SET_GROUP_MEMBERS'
export const BAN_USER = 'BAN_USER'
export const UNBAN_USER = 'UNBAN_USER'
export const SET_GROUP_FILTER = 'SET_GROUP_FILTER'
export const GET_POSTS_BY_GROUP = 'GET_POSTS_BY_GROUP'
export const GET_POSTS_BY_BUILDING = 'GET_POSTS_BY_BUILDING'
export const APPROVE_POST = 'APPROVE_POST'

const initialState = {
  groups: [],
  groupFilter: allGroupsOption,
  loadedAllPosts: false,
  loadingMembers: true,
  loadedAllMembers: false,
}

const removeDuplic = (arr) => {
  const tempArr = []
  return arr
    .map((obj) => {
      if (!tempArr.includes(obj.id)) {
        tempArr.push(obj.id)
        return obj
      } else {
        return undefined
      }
    })
    .filter((x) => x)
}

const createGroupsPosts = (state, action) => {
  const findCreatedPost = (postGroupId) =>
    action.data.find(({ groupId }) => groupId === postGroupId)

  const findGroupWhereToAddPost = (groupId) => action.groupIds.includes(groupId)

  const groupsWithNewPosts = state.groups.map((group) =>
    findGroupWhereToAddPost(group.id)
      ? {
          ...group,
          posts: [findCreatedPost(group.id), ...(group.posts || [])],
        }
      : group,
  )

  return {
    ...state,
    groups: groupsWithNewPosts,
  }
}

const groupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_GROUP_FILTER:
      return {
        ...state,
        groupFilter: action.group,
      }
    case SET_GROUPS:
      return {
        ...state,
        groups: action.data ? action.data : state.groups,
      }
    case UPDATE_GROUP:
      return {
        ...state,
        groups: state.groups.map((group) =>
          group.id === action.updatedGroup.id
            ? { members: group.members, ...action.updatedGroup }
            : group,
        ),
      }
    case SET_GROUP_MEMBERS:
      return {
        ...state,
        loadedAllMembers: action.loadedAll,
        groups: state.groups.map((group) =>
          group.id === action.groupId
            ? {
                ...group,
                members: {
                  ...group.members,
                  users:
                    action.page === 1
                      ? action.members
                      : removeDuplic([...group.members.users, ...action.members]),
                },
              }
            : group,
        ),
      }
    case BAN_USER:
      return {
        ...state,
        groups: state.groups.map((group) =>
          group.id === action.groupId
            ? {
                ...group,
                members: {
                  ...group.members,
                  users: group.members.users.map((user) =>
                    user.id === action.userId ? { ...user, banned: true } : user,
                  ),
                },
              }
            : group,
        ),
      }
    case UNBAN_USER:
      return {
        ...state,
        groups: state.groups.map((group) =>
          group.id === action.groupId
            ? {
                ...group,
                members: {
                  ...group.members,
                  users: group.members.users.map((user) =>
                    user.id === action.userId ? { ...user, banned: false } : user,
                  ),
                },
              }
            : group,
        ),
      }
    case GET_POSTS_BY_GROUP: {
      return {
        ...state,
        loadedAllPosts: action.loadedAllPosts,
        groups: state.groups.map((group) =>
          group.id === action.data.groupId
            ? {
                ...group,
                posts:
                  action.skip === 0
                    ? action.data.posts
                    : group.posts
                      ? unionWith(action.data.posts, group.posts, isEqual)
                      : action.data.posts,
              }
            : group,
        ),
      }
    }
    case GET_POSTS_BY_BUILDING: {
      return {
        ...state,
        loadedAllPosts: action.loadedAllPosts,
        groups: state.groups.map((group) => ({
          ...group,
          posts:
            action.skip === 0
              ? action.data.posts.filter((post) => post.groupId === group.id)
              : group.posts
                ? unionWith(
                    action.data.posts.filter((post) => post.groupId === group.id),
                    group.posts,
                    isEqual,
                  )
                : action.data.posts.filter((post) => post.groupId === group.id),
        })),
      }
    }
    case DELETE_POST:
      return {
        ...state,
        groups: state.groups.map((group) =>
          group.id === action.groupId
            ? {
                ...group,
                posts: group.posts.filter((post) => post.id !== action.postId),
              }
            : group,
        ),
      }
    case LIKE_POST:
      return {
        ...state,
        groups: state.groups.map((group) =>
          group.id === action.groupId
            ? {
                ...group,
                posts: group.posts.map((post) =>
                  post.id === action.postId
                    ? { ...post, likes: [...post.likes, action.likeData] }
                    : post,
                ),
              }
            : group,
        ),
      }
    case DISLIKE_POST:
      return {
        ...state,
        groups: state.groups.map((group) =>
          group.id === action.groupId
            ? {
                ...group,
                posts: group.posts.map((post) =>
                  post.id === action.postId
                    ? {
                        ...post,
                        likes: post.likes.filter(
                          (like) => like.author.email !== action.likeData.author.email,
                        ),
                      }
                    : post,
                ),
              }
            : group,
        ),
      }
    case CREATE_POST:
      return {
        ...state,
        groups: state.groups.map((group) =>
          group.id === action.groupId
            ? { ...group, posts: group.posts ? [action.data, ...group.posts] : [action.data] }
            : group,
        ),
      }
    case CREATE_POSTS:
      return createGroupsPosts(state, action)
    case UPDATE_POST:
      return {
        ...state,
        groups: state.groups.map((group) =>
          group.id === action.groupId
            ? {
                ...group,
                posts: group.posts
                  ? group.posts.map((post) =>
                      post.id === action.postId ? { ...post, ...action.data } : post,
                    )
                  : [action.data],
              }
            : group,
        ),
      }
    case ADD_COMMENT:
      return {
        ...state,
        groups: state.groups.map((group) =>
          group.id === action.groupId
            ? {
                ...group,
                posts: group.posts.map((post) =>
                  post.id === action.postId
                    ? {
                        ...post,
                        comments: post.comments ? [...post.comments, action.data] : [action.data],
                      }
                    : post,
                ),
              }
            : group,
        ),
      }
    case DELETE_COMMENT:
      return {
        ...state,
        groups: state.groups.map((group) =>
          group.id === action.groupId
            ? {
                ...group,
                posts: group.posts.map((post) =>
                  post.id === action.postId
                    ? {
                        ...post,
                        comments: post.comments.filter(({ id }) => id !== action.commentId),
                      }
                    : post,
                ),
              }
            : group,
        ),
      }
    case LIKE_COMMENT:
      return {
        ...state,
        groups: state.groups.map((group) =>
          group.id === action.groupId
            ? {
                ...group,
                posts: group.posts.map((post) =>
                  post.id === action.postId
                    ? {
                        ...post,
                        comments: post.comments.map((comment) =>
                          comment.id === action.commentId
                            ? {
                                ...comment,
                                likes: comment.likes
                                  ? [...comment.likes, action.likeData]
                                  : [action.likeData],
                              }
                            : comment,
                        ),
                      }
                    : post,
                ),
              }
            : group,
        ),
      }
    case DISLIKE_COMMENT:
      return {
        ...state,
        groups: state.groups.map((group) =>
          group.id === action.groupId
            ? {
                ...group,
                posts: group.posts.map((post) =>
                  post.id === action.postId
                    ? {
                        ...post,
                        comments: post.comments.map((comment) =>
                          comment.id === action.commentId
                            ? {
                                ...comment,
                                likes: comment.likes.filter(
                                  (like) => like.author.email !== action.likeData.author.email,
                                ),
                              }
                            : comment,
                        ),
                      }
                    : post,
                ),
              }
            : group,
        ),
      }
    case APPROVE_POST:
      return {
        ...state,
        groups: state.groups.map((group) =>
          group.id === action.groupId
            ? {
                ...group,
                posts: group.posts.map((post) =>
                  post.id === action.postId
                    ? {
                        ...post,
                        approved: true,
                      }
                    : post,
                ),
              }
            : group,
        ),
      }
    case SET_LOADING_MEMBERS:
      return {
        ...state,
        loadingMembers: action.loadingMembers,
      }
    default:
      return state
  }
}

// /////////////// METHODS

export const getPosts = (buildingId, groupId, skip, scheduled) => {
  const pageSize = 10
  return async (dispatch) => {
    try {
      if (groupId) {
        const { data } = await API.getGroupPosts(groupId, skip, pageSize, scheduled)
        dispatch({
          type: GET_POSTS_BY_GROUP,
          data: { posts: data, groupId },
          skip,
          loadedAllPosts: data.length < pageSize,
        })
      } else {
        const { data } = await API.getGroupsPosts(buildingId, skip, pageSize, scheduled)
        dispatch({
          type: GET_POSTS_BY_BUILDING,
          data: { posts: data },
          skip,
          loadedAllPosts: data.length < pageSize,
        })
      }
    } catch ({ message }) {
      throw new Error(message)
    }
  }
}

export const createPost = (groupId, newPostData) => {
  return async (dispatch) => {
    try {
      const { data } = await API.createPost(groupId, newPostData)
      dispatch({ type: CREATE_POST, groupId, data })
    } catch ({ message }) {
      throw new Error(message)
    }
  }
}

export const createPosts = (groupIds, newPostData) => {
  return async (dispatch) => {
    try {
      const { data } = await API.createPostForMultipleGroups(newPostData)
      dispatch({ type: CREATE_POSTS, groupIds, data })
    } catch ({ message }) {
      throw new Error(message)
    }
  }
}

export const updatePost = (groupId, postId, editData) => {
  return async (dispatch) => {
    try {
      const { data } = await API.updatePost(groupId, postId, editData)
      dispatch({ type: UPDATE_POST, groupId, postId, data })
    } catch ({ message }) {
      throw new Error(message)
    }
  }
}

export const deletePost = (groupId, postId) => {
  return async (dispatch) => {
    try {
      await API.deleteGroupsPost(groupId, postId)
      dispatch({ type: DELETE_POST, groupId, postId })
    } catch (err) {
      throw new Error(err)
    }
  }
}

export const addComment = (groupId, postId, addCommentData) => {
  return async (dispatch) => {
    try {
      const { data } = await API.addPostComment(groupId, postId, addCommentData)
      dispatch({ type: ADD_COMMENT, groupId, postId, data })
    } catch (err) {
      throw new Error(err)
    }
  }
}

export const deleteComment = (groupId, postId, commentId) => {
  return async (dispatch) => {
    try {
      await API.deletePostComment(groupId, postId, commentId)
      dispatch({ type: DELETE_COMMENT, groupId, postId, commentId })
    } catch (err) {
      throw new Error(err)
    }
  }
}

export const handleLikeFlow = (liked, groupId, postId, commentId, likeData) => {
  return async (dispatch) => {
    try {
      if (commentId) {
        if (!liked) {
          await API.likeComment(groupId, postId, commentId)
          dispatch({ type: LIKE_COMMENT, groupId, postId, commentId, likeData })
        } else {
          await API.dislikeComment(groupId, postId, commentId)
          dispatch({ type: DISLIKE_COMMENT, groupId, postId, commentId, likeData })
        }
      } else if (!liked) {
        await API.likeGroupsPost(groupId, postId)
        dispatch({ type: LIKE_POST, groupId, postId, likeData })
      } else {
        await API.dislikeGroupsPost(groupId, postId)
        dispatch({ type: DISLIKE_POST, groupId, postId, likeData })
      }
    } catch (err) {
      throw new Error(err)
    }
  }
}

export const setGroupForFilter = (group) => ({
  type: SET_GROUP_FILTER,
  group,
})

const setLoadingGroupMembers = (loadingMembers) => {
  return {
    type: SET_LOADING_MEMBERS,
    loadingMembers,
  }
}

export const setLoadingGroupMembersState = (loadingMembers) => {
  return function (dispatch) {
    dispatch(setLoadingGroupMembers(loadingMembers))
  }
}

export const banUserFromGroup = (groupId, userId) => {
  return function (dispatch) {
    return API.banUserFromGroup(groupId, userId)
      .then(() => {
        dispatch({
          type: BAN_USER,
          groupId,
          userId,
        })
        return Promise.resolve()
      })
      .catch((err) => {
        throw new Error(err)
      })
  }
}

export const unbanUserFromGroup = (groupId, userId) => {
  return function (dispatch) {
    return API.unbanUserFromGroup(groupId, userId)
      .then(() => {
        dispatch({
          type: UNBAN_USER,
          groupId,
          userId,
        })
        return Promise.resolve()
      })
      .catch((err) => {
        throw new Error(err)
      })
  }
}

export const getGroupMembers = (page = 1, groupId, query = '', pageSize = 50) => {
  const start = (page - 1) * pageSize
  return function (dispatch) {
    return API.getGroupMembers(start, pageSize, groupId, query)
      .then((members) => {
        dispatch({
          type: SET_GROUP_MEMBERS,
          members,
          page,
          groupId,
          loadedAll: members.length < pageSize,
        })
        dispatch(setLoadingGroupMembers(false))
        return Promise.resolve(members)
      })
      .catch((err) => {
        dispatch(setLoadingGroupMembers(false))
        throw new Error(err)
      })
  }
}

export const getGroups = (buildingId, search = '', sortOrder = '') => {
  return async (dispatch) => {
    try {
      const { data } = await API.getGroups(buildingId, { search, sortOrder })
      dispatch({ type: SET_GROUPS, data, buildingId })
    } catch (err) {
      throw err
    }
  }
}

export const updateGroup = (newGroupData, groupId) => {
  return async (dispatch) => {
    try {
      const data = await API.updateGroup(newGroupData, groupId)
      dispatch({ type: UPDATE_GROUP, updatedGroup: data })
      return data
    } catch ({ message }) {
      throw new Error(message)
    }
  }
}

export const approvePost = (groupId, postId) => {
  return async (dispatch) => {
    try {
      await API.approveGroupsPost(groupId, postId)
      dispatch({ type: APPROVE_POST, groupId, postId })
    } catch ({ message }) {
      throw new Error(message)
    }
  }
}

export const sortByDate = (array, ascending) => {
  return [...array].sort((a, b) =>
    !ascending ? b.createdAt - a.createdAt : a.createdAt - b.createdAt,
  )
}

// /////////////// SELECTORS
export const selectGroups = (state) => state.groups.groups

export const selectGroupFilter = (state) => state.groups.groupFilter

export const selectStatusOfGroupMembersLoading = (state) => state.groups.loadingMembers

export const selectStatusOfGroupMembersLoadingAll = (state) => state.groups.loadedAllMembers

export const selectGroupById = createSelector(selectGroups, (groups) => (id) => {
  if (id === 'new') {
    return null
  }

  return groups.find((group) => group.id === parseInt(id)) || groups[0] || null
})

export const selectGroupMembersById = createSelector(selectGroups, (groups) => (id) => {
  return groups.find((group) => group.id === parseInt(id)).members.users || []
})

export const selectPosts = createSelector(
  [selectGroups, (_, groupId) => groupId],
  (groups, groupId) => {
    if (!groups) return []

    if (groupId) {
      const group = groups.find((g) => g.id === groupId)
      return group?.posts ?? []
    }

    return groups.flatMap((g) => g.posts ?? [])
  },
)

export const selectStatusIsLoadedAllPosts = (state) => state.groups.loadedAllPosts

export default groupsReducer
